import { useColors } from "../../../../../hooks/colors/useColors";
import { useUser } from "../../../../../hooks/react-query/useUser";
import { useRedirectAnonymous } from "../../../../../hooks/auth/useRedirectAnonymous";
import { Container } from "../../../../../components/UI/container/Container";
import { bookingStore } from "../../../../../components/config/store/bookingStore";
import { IconX } from "@tabler/icons";
import { Avatar, Text } from "@mantine/core";
import { MyH1 } from "../../../../../components/UI/my-h1/MyH1";
import { MyButton } from "../../../../../components/UI/my-button/MyButton";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { isMobile } from "react-device-detect";
import { MyHead } from "../../../../../components/pages/MyHead";
import { Fragment } from "react";
import { Footer } from "../../../../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function BookingPage() {
  const { colors } = useColors();
  const redirect = useRedirectAnonymous();
  const router = useRouter();
  const { user, userIsLoading } = useUser();
  const { errorMessage } = bookingStore((state) => state);
  const { t } = useTranslation("common");

  async function goBack() {
    await router.back();
  }

  return (
    <Fragment>
      <MyHead
        title={t("booking.BOOKING_ERROR")}
        description={t("booking.BOOKING_ERROR")}
      />
      {user && !userIsLoading && (
        <Container noHeight>
          <div
            style={{ minHeight: "calc(100vh - 300px)" }}
            className="flex flex-col justify-center items-center gap-4"
          >
            <Avatar
              styles={{ placeholder: { backgroundColor: colors.danger } }}
              radius={150}
              size={300}
            >
              <IconX size={300} color={colors.white} />
            </Avatar>
            <MyH1 size={isMobile ? "2.5rem" : "3rem"} centerText>
              {t(`booking.error`)}
            </MyH1>
            <Text className="text-2xl text-center">
              {t(`booking.${errorMessage}`)}
            </Text>
            <MyButton
              marginTop
              size="xl"
              fontSize="1.5rem"
              height="3rem"
              onClick={goBack}
              title={t("back")}
              color={colors.secondary}
            />
          </div>
        </Container>
      )}
      <Footer isVisible />
    </Fragment>
  );
}

export default BookingPage;
